import { i18n }               from '../../../../shared/i18n/i18n.js'

import { getSortEntry }     from '../../registries/sortRegistry.js'
import { 
  DEFAULT_COLUMN_WIDTH,
  LIST_COLUMN_UI_MAP }      from './columnUiRegistry.jsx'
import { VIEW_MODE }        from '../../utils/viewModes.js'

export function buildColumnDefs(listColumns, context = {}) {

  return listColumns.map((item) => {
    const uiDef = LIST_COLUMN_UI_MAP[item.id] ?? {}

    // Sorting with column header depends on presence and support in SORT_REGISTRY
    const isSortable = Boolean(getSortEntry(item.id)?.isSupported(context))

    // Static or dynamic column width
    const width = typeof uiDef.width === 'function' ? uiDef.width(context) : (uiDef.width ?? DEFAULT_COLUMN_WIDTH)

    return {
      id: item.id,
      label: i18n.t(item.labelKey),
      width,
      align: uiDef.align ?? 'center',
      sortable: isSortable,
      
      // Render: dedicated JSX from UI Map OR fallback to clean getValue() from CATALOG_DISPLAY_REGISTRY!
      render: (product) => {
        if (typeof uiDef.render === 'function') {
          const renderContext = {
            ...context,
            viewMode: VIEW_MODE.LIST,
          }
          return uiDef.render(product, renderContext) //this context must be ehanced with fields for actions and inquiry renders
        }
        return item.getValue?.(product, context) ?? '—'
      },
    }
  })
}